import { useQuery } from '@tanstack/react-query';

const SURVEY_LAST_EMAIL_KEY = (slug: string) => `survey_${slug}_last`;

/**
 * Reads the "last email" for a survey from localStorage (format useQuery).
 * Use the returned status (isLoading, isError, isSuccess) to decide what to render.
 */
export function useSurveyLastEmail(slug: string) {
  return useQuery({
    queryKey: ['survey-last-email', slug],
    queryFn: async (): Promise<string | null> => {
      if (typeof window === 'undefined') return null;
      const value = localStorage.getItem(SURVEY_LAST_EMAIL_KEY(slug));
      return value ?? null;
    },
    enabled: !!slug,
  });
}
